import { useEffect, useRef, useState } from 'react';

export default function FeedbackDialog({ itemName, title, onSubmit, onClose }) {
  const [feedback, setFeedback] = useState('');
  const [error, setError] = useState('');
  const fieldRef = useRef(null);

  useEffect(() => {
    fieldRef.current?.focus();
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [onClose]);

  const submit = (event) => {
    event.preventDefault();
    const value = feedback.trim();
    if (!value) {
      setError('Feedback is required.');
      fieldRef.current?.focus();
      return;
    }
    onSubmit(value);
  };

  return (
    <div className="feedback-backdrop" role="presentation" onMouseDown={onClose}>
      <section className="feedback-dialog" role="dialog" aria-modal="true" aria-labelledby="feedback-title" onMouseDown={(event) => event.stopPropagation()}>
        <div className="feedback-dialog__top">
          <span className="feedback-dialog__icon" aria-hidden="true">✎</span>
          <button type="button" className="feedback-dialog__close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <h2 id="feedback-title">{title}</h2>
        <p>Provide clear feedback so the responsible team can make the required changes.</p>
        <div className="feedback-dialog__item">{itemName}</div>
        <form onSubmit={submit} noValidate>
          <label htmlFor="revision-feedback">Feedback / guidance <span className="required-mark" aria-hidden="true">*</span></label>
          <textarea ref={fieldRef} id="revision-feedback" value={feedback} onChange={(event) => { setFeedback(event.target.value); if (error) setError(''); }} placeholder="Describe the required changes and guidance…" rows="5" maxLength="1000" className={error ? 'input-error' : ''} aria-invalid={Boolean(error)} aria-describedby={error ? 'revision-feedback-error' : 'revision-feedback-help'} />
          {error ? <small className="field-error" id="revision-feedback-error" role="alert">{error}</small> : <small className="feedback-dialog__help" id="revision-feedback-help">Be specific and include the expected correction.</small>}
          <div className="feedback-dialog__actions">
            <button className="quiet" type="button" onClick={onClose}>Cancel</button>
            <button className="primary" type="submit">Submit feedback</button>
          </div>
        </form>
      </section>
    </div>
  );
}
